import { IItemNumberComposition } from "../../../types/data.interface";
import { mapTccCompositionDTOToModel } from "../../../helpers/tcc-composition.helper";

const itemNumberCompositionDTO = (composition: any[]) => {
  const mappedComposition: IItemNumberComposition[] = [];

  try{
    composition.forEach((comp: any) => {
      mappedComposition.push({
        id: comp.id,
        region: { id: 0, name: "" },
        artwork: comp?.artwork,
        color: comp?.color,
        componentType: comp?.non_mold ? "NonMolded" : "Molded",
        decorTech: comp?.decorTech,
        index: "",
        isRestrictive: false,
        mold: comp?.mold,
        nonMold: comp?.non_mold,
        pcs: comp.itn_compcs,
        componentTypeOf: comp.itn_comtyp,
        componentNumber: comp.itn_comnum,
        mktMaterial: comp.itn_cmtmkt,
        isMandatory: comp.itn_commnd,
        componentName: comp?.itn_comtyp,
      });
    });
  }
  catch (e){
  }

  return mappedComposition
};


export const itemNumbersDTO = (itemNumber:any) => {
  const mappedItemNumber:any[] = []

  itemNumber.forEach((itn:any) => {

    const mapped = itn
    mapped["itn_compos"] = itemNumberCompositionDTO(itn["itn_compos"])

    mapped["tcc_compositions"] = mapTccCompositionDTOToModel(
      itn["tcc_compositions"],
    );

    mappedItemNumber.push(mapped)
  })

  return mappedItemNumber
};

export const itemNumberDTO = (itemNumber:any) => {
  const mappedItemNumber = {...itemNumber}

  mappedItemNumber["itn_compos"] = itemNumberCompositionDTO(
    mappedItemNumber["itn_compos"],
  );
  mappedItemNumber["tcc_compositions"] = mappedItemNumber[
    "tcc_compositions"
  ]?.map((tccComp: any) => mapTccCompositionDTOToModel(tccComp));

  return mappedItemNumber

}

export const getItemNumber = async (axios: any, updateState: any, id?:any, code?:any, setIsLoading?:(val:boolean) => void) => {
  const url = !!id ? `tccs/${id}`:"tccs";
  const searchParams = new URLSearchParams();
  if(code){
    searchParams.append("search", code)
  }
  searchParams.append("limit", "50")

  const controller = new AbortController();

  // setIsLoading(true);
  const res = await axios.get(`${url}?${searchParams.toString()}`, {signal:controller.signal});
  if (res.status === 200) {
    if (res.data.hasOwnProperty("results")) {
      if (!!setIsLoading) setIsLoading(false);
      return updateState(res.data.results);
    }

    const mappedItemNumber = itemNumbersDTO(res.data)
    if (!!setIsLoading) setIsLoading(false);
    return updateState(mappedItemNumber);
  } else {
    if (!!setIsLoading) setIsLoading(false);
    return null;
  }
};
